<template>
  <div>
    <!-- Header -->
    <div class="header bg-home py-1">
      <div class="container">
        <div class="header-body text-center mb-7">
          <div class="row justify-content-center">

          </div>
        </div>
      </div>
      <div class="separator separator-bottom separator-skew zindex-100">
        <svg x="0" y="0" viewBox="0 0 860 100" preserveAspectRatio="none" version="1.1" xmlns="http://www.w3.org/2000/svg">
          <polygon class="fill-default" points="860 0 860 100 0 100"></polygon>
        </svg>
      </div>
    </div>
    <section id="intro-content">
      <div class="container">

        <base-progress style="width: 80%; margin: auto" show-label type="secondary" label="Progresso" :height="4" :value="progressValue" ></base-progress>
        <div class="py-4">
          <div class="icon-category">
            <div class="bg-home">
              <small>GERAL</small>
            </div>
          </div>
          <h2 class="display-3 pt-2">Informações Gerais</h2>
          <p class="lead">Primeiro vamos conhecer melhor você.</p>
        </div>
        <validation-observer v-slot="{handleSubmit}" ref="formValidator">
          <form id="qa1" class="needs-validation qa"
                @submit.prevent="handleSubmit(nextPage)">

            <div class="form-row">

              <div class="col-md-6">
                <base-input @change="update()"
                            label="Seu nome"
                            name="Nome Completo"
                            placeholder="Nome e Sobrenome"
                            rules="required"
                            success-message="Tudo certo!"
                            v-model="userData.fullName">
                </base-input>
              </div>
            </div>

            <div class="form-row cep" style="display: flex !important;">
              <div class="col-md-3 col-xs-6">
                <base-input @focusout="update()"
                            label="Cidade"
                            name="Cidade"
                            rules="required"
                            placeholder="Cidade"
                            v-model="userData.city">
                </base-input>
              </div>

              <div class="col-md-3 col-xs-6">
                <base-input label="Estado"
                            rules="required"
                            name="Estado"
                >
                  <el-select v-model="userData.state" @change="update()" filterable
                             placeholder="Selecione">
                    <el-option v-for="item in states" :key="item" :label="item" :value="item"></el-option>
                  </el-select>
                </base-input>
              </div>
            </div>


            <div class="form-row cep" style="display: flex !important;">
              <div class="col-md-3 col-xs-6">
                <base-input @focusout="update()"
                            label="Idade"
                            name="Idade"
                            type="tel"
                            rules="required"
                            placeholder="Idade"
                            v-model="userData.age">
                </base-input>
              </div>
              <div class="col-md-3 col-xs-6">
                <base-input
                  label="Gênero"
                  name="Gênero"
                  rules="required"
                >
                  <el-select v-model="userData.gender" @change="update()" filterable
                             placeholder="Gênero">
                    <el-option v-for="item in gender" :key="item" :label="item" :value="item"></el-option>
                  </el-select>
                </base-input>
              </div>

            </div>


            <div class="align-center">
              <base-button outline type="secondary" class="back-btn" @click="prevPage()">Voltar</base-button>
              <base-button type="secondary" native-type="submit">Avançar</base-button>
            </div>
          </form>
        </validation-observer>
      </div>
    </section>
    <!-- Page content -->


  </div>
</template>

<script>
  import 'vue-range-slider/dist/vue-range-slider.css'
  // import RangeSlider from 'vue-range-slider'
  import { Select, Option } from 'element-ui'

  export default {
    name: 'benchmark',
    components: {
      [Select.name]: Select,
      [Option.name]: Option,
    },
    data: () => ({
      validated: false,
      slider: 0,
      gender: [
        "Masculino",
        "Feminino",
        "Outro"
      ],
      states: [
        "Acre",
        "Alagoas",
        "Amapá",
        "Amazonas",
        "Bahia",
        "Ceará",
        "Distrito Federal",
        "Espírito Santo",
        "Goiás",
        "Maranhão",
        "Mato Grosso",
        "Mato Grosso do Sul",
        "Minas Gerais",
        "Pará",
        "Paraíba",
        "Paraná",
        "Pernambuco",
        "Piauí",
        "Rio de Janeiro",
        "Rio Grande do Norte",
        "Rio Grande do Sul",
        "Rondônia",
        "Roraima",
        "Santa Catarina",
        "São Paulo",
        "Sergipe",
        "Tocantins",
      ],
      money: {
        locale: 'pt-BR',
        currency: 'BRL',
        valueAsInteger: true,
        distractionFree: false,
        precision: 0,
        autoDecimalMode: true,
        allowNegative: false
      },
      userData: {
        fullName: '',
        city: '',
        state: '',
        age: '',
        gender: ''
      },
      progressValue: 0,
    }),
    methods: {
      prevPage () {
        this.$router.push('intro')
      },
      update () {
        window.localStorage.setItem("userData", JSON.stringify(this.userData))
      },
      async nextPage () {
        window.localStorage.setItem("userData", JSON.stringify(this.userData))
        await this.$router.push('qa1')
      }

    },
    created() {
      let userPayload = window.localStorage.getItem("userData")

      if (userPayload != null) {
        this.userData = JSON.parse(userPayload)
      }
    }
  };
</script>
<style></style>
